<template>
  <CardModule title="Documentos" class="mt-6">
    <v-row>
      <v-col cols="12" sm="6">
        <BaseSelect
          label="Tipo de documento"
          placeholder="Tipo de documento"
          item-text="key"
          item-value="value"
          no-data-text="Todos os documentos já foram incluídos."
          persistent-hint
          :items="filteredData"
          :hint="typeDocHint"
          :error-messages="$pointOfSale.cadastro.documentos.error.documento"
          @input="$pointOfSale.cadastro.documentos.error.documento = []"
          v-model="$pointOfSale.cadastro.documentos.documento"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-file-input
          outlined
          dense
          clearable
          clear-icon="mdi-close-circle-outline"
          show-size
          prepend-icon=""
          append-icon="mdi-paperclip"
          class="rounded-lg"
          hide-details
          accept="image/png, image/jpeg, image/bmp"
          placeholder="Clique aqui para importar a imagem"
          :color="this.$vuetify.theme.themes.light.secondary"
          @click:clear="clearDOC()"
          @change="
            getDOC($pointOfSale.cadastro.documentos.documento_upload.object)
          "
          v-model="$pointOfSale.cadastro.documentos.documento_upload.object"
        >
        </v-file-input>
      </v-col>
    </v-row>
    <v-row no-gutters class="justify-end">
      <BaseButton
        :color="$config.dados.corinputs"
        :loading="$pointOfSale.cadastro.documentos.loading_documento"
        class="button rounded-lg mt-4 mb-6"
        @click="
          uploadDOC($pointOfSale.cadastro.documentos.documento_upload.doc)
        "
        >Fazer upload
        <v-icon small class="ml-2">mdi-upload</v-icon>
      </BaseButton>
    </v-row>
    <div class="documentos-table" v-if="isPFandHaveDocsInArray">
      <span>Não há registro de documentos para este ponto de venda.</span>
    </div>
    <div
      class="documentos-table"
      v-else-if="
        $pointOfSale.cadastro.dados_cadastrais.pessoa === 'JURIDICA' &&
        $pointOfSale.cadastro.documentos &&
        $pointOfSale.cadastro.documentos.documento_array_pj &&
        $pointOfSale.cadastro.documentos.documento_array_pj.length == 0
      "
    >
      <span>Não há registro de documentos para este ponto de venda.</span>
    </div>
    <v-simple-table fixed-header class="documentos-table" v-else>
      <template v-slot:default>
        <thead>
          <tr>
            <th
              v-for="(header, index) in headersDocs"
              :key="index"
              class="text-center table-header"
            >
              {{ header.title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(doc, index) in tipoPessoaTable" :key="index">
            <td class="text-center">{{ Object.keys(doc)[0] }}</td>
            <td class="text-center">{{ Object.values(doc)[0] }}</td>
            <td class="table-actions">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    width="30"
                    small
                    icon
                    @click="previewImage(Object.values(doc)[0])"
                  >
                    <v-icon class="documentos-icon">mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Acessar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    v-bind="attrs"
                    v-on="on"
                    width="30"
                    small
                    icon
                    @click="
                      $pointOfSale.documentRemove(
                        index,
                        Object.keys(doc)[0],
                        'Deseja realmente excluir esta imagem?'
                      )
                    "
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Deletar</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </CardModule>
</template>
<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import PDVmixins from "@/mixins/PDV.mixins.js";
export default {
  name: "Documents",
  mixins: [PDVmixins],
  components: {
    CardModule,
    BaseSelect,
    BaseButton,
  },
  computed: {
    filteredData() {
      if (this.$pointOfSale.cadastro.dados_cadastrais.pessoa == "FISICA") {
        return this.$pointOfSale?.tipo_docs_pf?.filter(
          item => item.show === true
        );
      } else {
        return this.$pointOfSale?.tipo_docs_pj?.filter(
          item => item.show === true
        );
      }
    },
    tipoPessoaTable() {
      if (this.$pointOfSale.cadastro.dados_cadastrais.pessoa === "FISICA") {
        return this.$pointOfSale?.cadastro.documentos?.documento_array_pf;
      } else {
        return this.$pointOfSale?.cadastro.documentos?.documento_array_pj;
      }
    },
    typeDocHint() {
      if (this.$pointOfSale.cadastro.dados_cadastrais.pessoa === "FISICA") {
        return "Documentos obrigatórios para completar o cadastro: Documento (RG, CPF ou CNH) e Comprovante de Endereço.";
      }
      return "Documentos obrigatórios para completar o cadastro: Contrato Social e Comprovante de Endereço.";
    },
    isPFandHaveDocsInArray() {
      return (
        this.$pointOfSale.cadastro.dados_cadastrais.pessoa === "FISICA" &&
        this.$pointOfSale.cadastro.documentos &&
        this.$pointOfSale.cadastro.documentos.documento_array_pf &&
        this.$pointOfSale.cadastro.documentos.documento_array_pf.length === 0
      );
    },
  },
  watch: {
    "$pointOfSale.cadastro.documentos.documento_array_pj"(e) {
      if (e.length >= 1) {
        e.forEach(obj => {
          const docsFilter = this.$pointOfSale.tipo_docs_pj.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (docsFilter) {
            this.$pointOfSale?.tipo_docs_pj?.map((item, index) => {
              if (docsFilter.value == item.value) {
                this.$pointOfSale.tipo_docs_pj[index].show = false;
              }
            });
          }
          // }
        });
      }
    },
    "$pointOfSale.cadastro.documentos.documento_array_pf"(e) {
      if (e.length >= 1) {
        e.forEach(obj => {
          const docsFilter = this.$pointOfSale?.tipo_docs_pf?.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (docsFilter) {
            this.$pointOfSale?.tipo_docs_pf?.map((item, index) => {
              if (docsFilter.value === item.value) {
                this.$pointOfSale.tipo_docs_pf[index].show = false;
              }
            });
          }
        });
      }
    },
  },
  mounted() {
    this.$pointOfSale?.tipo_docs_pf?.forEach((obj, index) => {
      if (
        this.$pointOfSale.cadastro.documentos.documento_array_pf.length >= 1
      ) {
        const docsFilter =
          this.$pointOfSale?.cadastro?.documentos?.documento_array_pf?.find(
            o => Object.keys(o)[0] === obj.value
          );
        if (docsFilter) {
          this.$pointOfSale.tipo_docs_pf[index].show = false;
        }
      }
    });
    this.$pointOfSale?.tipo_docs_pj?.forEach((obj, index) => {
      if (
        this.$pointOfSale.cadastro.documentos.documento_array_pj.length >= 1
      ) {
        const docsFilter =
          this.$pointOfSale?.cadastro?.documentos?.documento_array_pj?.find(
            o => Object.keys(o)[0] === obj.value
          );
        if (docsFilter) {
          this.$pointOfSale.tipo_docs_pj[index].show = false;
        }
      }
    });
  },
};
</script>
<style scoped>
.pdv-documentos {
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
.input-file-tema {
  border-radius: 0.625rem;
  width: 100%;
}
.documentos-table {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 1.25rem !important;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.documentos-icon {
  fill: var(--dl-color-gray-white) !important;
  width: 1.5rem;
  height: 1.5rem;
}

.doc-upload-button1 {
  color: var(--dl-color-gray-white) !important;
  width: 1.875rem;
  height: 1.875rem;
  display: flex;
  padding: 0;
  align-items: center;
  border-width: 0;
  margin-right: 0.625rem;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.doc-upload-button2 {
  color: var(--dl-color-gray-white);
  width: 1.875rem;
  height: 1.875rem;
  display: flex;
  padding: 0;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
